var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function({hover}){return [_c('app-icon',{staticClass:"component-container",class:_vm.isActive && 'orange rounded-pill',attrs:{"color":hover || _vm.isActive ? 'white' : '',"icon":"edit","title":"Edit"}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }